import { formatNumber } from '@/utils/coins/formatNumber';

/**
 * Gold "bubble" symbols (sekee_bubbler, sekeb_blubber, bub_18ayar, …) are the gap between a coin's
 * market price and its gold value, so Market Pulse may send them negative. Only these keep a sign.
 */
export const isBubbleSymbol = (symbol?: string | null): boolean =>
    /bubbl|blubber|^bub_/i.test(symbol || '');

/**
 * Toman amount for display. Bubbles get an explicit +/- next to the digits; render the result in an
 * LTR isolate (`<bdi dir='ltr'>`) so the sign stays attached to the number in the RTL layout.
 */
export const formatTomanPrice = (value: number, symbol?: string | null): string => {
    const number = Number(value) || 0;
    if (!isBubbleSymbol(symbol)) {
        return formatNumber(number, false, true, 'TMN', true);
    }
    const sign = number > 0 ? '+' : number < 0 ? '-' : '';
    return `${sign}${formatNumber(Math.abs(number), false, true, 'TMN', true)}`;
};
